import { Subject } from 'rxjs';
import { ListingPageModelWithRefresh } from './listing-page-model.types';

export class ListingPageModelAbstract implements ListingPageModelWithRefresh {
  readonly shouldRefresh = new Subject<void>();

  refresh(): void {
    this.shouldRefresh.next();
  }
}
